$(document).ready(function () {
  const triggerModal = (clickedSlide) => {
    clickedSlide.classList.add("active");
    const modal = document.getElementById(clickedSlide.dataset.modalId);
    if (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      modal.classList.add("active");

      if (!modal.dataset.closeBound) {
        modal.dataset.closeBound = "true";
        modal.addEventListener("click", (event) => {
          if (
            !event.target.closest(".expanding-blocks-modal__close") &&
            event.target.closest(".expanding-blocks-modal__card")
          )
            return;

          modal.classList.remove("active");
          document
            .querySelectorAll(".expanding-blocks-item.active")
            .forEach((slide) => slide.classList.remove("active"));
        });
      }
    }
  };

  const swiper = new Swiper(
    ".expanding-blocks .expanding-blocks-items.swiper-container",
    {
      slidesPerView: 1.2,
      spaceBetween: 24,
      pagination: {
        el: ".expanding-blocks .swiper-pagination",
        clickable: true,
      },
      scrollbar: {
        el: ".expanding-blocks .swiper-scrollbar",
        draggable: true,
      },
      breakpoints: {
        480: {
          slidesPerView: 2.2,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 3.2,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3.2,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
      on: {
        init: function (swiper) {
          // Set the second block (index 1) as expanded by default
          const secondSlide = swiper.slides[1];
          if (secondSlide) {
            secondSlide.classList.add("expanded");
          }
        },
        click: function (swiper, event) {
          const clickedSlide = event.target.closest(".swiper-slide");
          if (!clickedSlide) return;

          triggerModal(clickedSlide);
        },
      },
    },
  );

  // Handle hover to expand/collapse on desktop
  if (window.innerWidth >= 1024) {
    document
      .querySelectorAll(".expanding-blocks-item")
      .forEach((item, index) => {
        item.addEventListener("mouseenter", function () {
          // Remove expanded class from all items
          document.querySelectorAll(".expanding-blocks-item").forEach((el) => {
            el.classList.remove("expanded");
          });
          // Add expanded class to hovered item
          this.classList.add("expanded");
        });
      });
  }
});
